var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceUnitVariation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    stroke: "#000000",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.12,58H20.88a2.33,2.33,0,0,1-2.33-2.33V28.89a1.15,1.15,0,0,1,.37-.85L30.73,17a1.16,1.16,0,0,1,1.56,0L45.05,28a1.18,1.18,0,0,1,.4.88V55.7A2.33,2.33,0,0,1,43.12,58Z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,25.2c-4.39,0-7.95-4.31-7.95-9.62S27.61,6,32,6s8,4.3,8,9.61",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.78,46.88a8.1,8.1,0,1,1-1.53-13.8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.68,
    y1: 38.07,
    x2: 36.17,
    y2: 38.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.68,
    y1: 43.12,
    x2: 34.54,
    y2: 43.12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceUnitVariation);
export default __webpack_public_path__ + "static/media/price-unit-variation.2dfd10131c5525264e472ace345b2003.svg";
export { ForwardRef as ReactComponent };